
import { defineComponent } from "vue";
import CancelConfirmButton from "@/components/shared/CancelConfirmButton.vue";

export default defineComponent({
  components: {
    CancelConfirmButton,
  },
  props: {
    fatesToPurchase: {
      type: Number,
      required: true,
    },
    primoBalance: {
      type: Number,
      required: true,
    },
    useStandardFates: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["cancel-wish", "wish"],
  computed: {
    primogemsNeeded(): number {
      return this.fatesToPurchase * 160;
    },
  },
  methods: {
    clickOutside(e: Event): void {
      if (e.target === document.getElementById("overlay-fate-purchase")) {
        this.$emit("cancel-wish");
      }
    },
  },
});
